import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { CountyWithMunicipalities } from 'src/features/one-way-in/hooks/use-geonorge';

const columnHelper = createColumnHelper<CountyWithMunicipalities>();

export const countyColumns = [
  columnHelper.accessor((row) => row.fylkesnavn, {
    id: 'Fylke',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.fylkesnummer, {
    id: 'Fylkesnummer',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
];
